// extracted by mini-css-extract-plugin
export default {"copyLinkModal":"CopyLinkModal_copyLinkModal__gVLJ7","copyLinkModalText":"CopyLinkModal_copyLinkModalText__eRfos"};